import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Title } from "../open-title";
import { CardProduct } from "./CardProduct";
import "./styles.less";

export const ApiComponent = () => {
  const { t } = useTranslation();
  const [currentPanel, setCurrentPanel] = useState("firstPanel");

  const [swipeNum, setSwipeNum] = useState(0);

  const computeSwipe = () => {
    const width =
      document.body?.clientWidth || document.documentElement?.clientWidth;

    if (width >= 1200) {
      setSwipeNum(0);
    } else if (width < 1200 && width >= 768) {
      setSwipeNum(12);
    } else {
      setSwipeNum(10);
    }
  };

  useEffect(() => {
    computeSwipe();
    window.addEventListener("resize", computeSwipe);
    return () => {
      window.removeEventListener("resize", computeSwipe);
    };
  }, []);

  const tabs = useMemo(() => {
    return [
      {
        value: "firstPanel",
        label: t("open.api.tabs.tab1.label"),
        icon: "//files.authing.co/authing-website/open/api-manage.png",
      },
      {
        value: "secondPanel",
        label: t("open.api.tabs.tab2.label"),
        icon: "//files.authing.co/authing-website/open/api-auth.png",
      },
    ];
  }, [t]);

  const firstProducts = [
    {
      icon: "website-user-settings-line",
      title: t("open.api.content.manageUsers"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%E7%94%A8%E6%88%B7%2F%E4%BD%BF%E7%94%A8%E8%87%AA%E5%AE%9A%E4%B9%89%E6%95%B0%E6%8D%AE%E5%BA%93%E5%AD%98%E5%82%A8%E7%94%A8%E6%88%B7%E6%95%B0%E6%8D%AE",
      apiNumber: 32,
    },
    {
      icon: "website-organization-chart",
      title: t("open.api.content.manageOrg"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%E7%BB%84%E7%BB%87%E6%9C%BA%E6%9E%84%2F%E4%BB%8E%E7%AC%AC%E4%B8%89%E6%96%B9%E5%AF%BC%E5%85%A5%E7%BB%84%E7%BB%87%E6%9C%BA%E6%9E%84",
      apiNumber: 23,
    },
    {
      icon: "website-user-4-line",
      title: t("open.api.content.manageRole"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%E8%A7%92%E8%89%B2%2F%E6%A6%82%E8%BF%B0",
      apiNumber: 14,
    },
    {
      icon: "website-group-line",
      title: t("open.api.content.manageUserGroups"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%E7%94%A8%E6%88%B7%E5%88%86%E7%BB%84%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FGroupsManagementController_getGroup",
      apiNumber: 10,
    },
    {
      icon: "website-list-settings-line",
      title: t("open.api.content.manageCustomField"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%E8%87%AA%E5%AE%9A%E4%B9%89%E5%AD%97%E6%AE%B5%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FCustomFieldsManagementController_getUserBaseFields",
      apiNumber: 6,
    },
    {
      icon: "website-pie-chart-line",
      title: t("open.api.content.manageResourcesAuth"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%E8%B5%84%E6%BA%90%E4%B8%8E%E6%9D%83%E9%99%90%2F%E5%9F%BA%E6%9C%AC%E6%A6%82%E5%BF%B5",
      apiNumber: 24,
    },
    {
      icon: "website-line-chart-line",
      title: t("open.api.content.manageDataResourcesAuth"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%E6%95%B0%E6%8D%AE%E8%B5%84%E6%BA%90%E4%B8%8E%E6%9D%83%E9%99%90%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FPermissionNamespaceManagementController_createPermissionNamespace",
      apiNumber: 21,
    },
    {
      icon: "website-command-fill",
      title: t("open.api.content.manageApps"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%E5%BA%94%E7%94%A8%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FApplicationsManagementController_getApplication",
      apiNumber: 14,
    },
    {
      icon: "website-contacts-line",
      title: t("open.api.content.manageIdentity"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%E8%BA%AB%E4%BB%BD%E6%BA%90%2F%E5%9F%BA%E6%9C%AC%E6%A6%82%E5%BF%B5",
      apiNumber: 12,
    },
    {
      icon: "website-phone-lock-line",
      title: t("open.api.content.manageSafeConfig"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%E5%AE%89%E5%85%A8%E9%85%8D%E7%BD%AE%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FSecurityAPIV3Controller_getSecuritySettings",
      apiNumber: 4,
    },
    {
      icon: "website-chat-settings-line",
      title: t("open.api.content.manageMessage"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%E6%B6%88%E6%81%AF%E6%9C%8D%E5%8A%A1%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FMessageManagementController_getEmailTemplates",
      apiNumber: 5,
    },
    {
      icon: "website-links-fill",
      title: t("open.api.content.manageSyncCenter"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%E5%90%8C%E6%AD%A5%E4%B8%AD%E5%BF%83%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FSyncCenterManagementController_getSyncTask",
      apiNumber: 11,
    },
    {
      icon: "website-terminal-box-line",
      title: t("open.api.content.managePipeline"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%20Pipeline%2F%E5%9F%BA%E6%9C%AC%E6%A6%82%E5%BF%B5",
      apiNumber: 8,
    },
    {
      icon: "website-computer-line",
      title: t("open.api.content.manageWebhook"),
      url:
        "?tag%2F%E7%AE%A1%E7%90%86%20Webhook%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FWebhookManagementController_createWebhook",
      apiNumber: 8,
    },
    {
      icon: "website-article-line",
      title: t("open.api.content.manageLog"),
      url:
        "?tag=tag%2F%E8%8E%B7%E5%8F%96%E5%AE%A1%E8%AE%A1%E6%97%A5%E5%BF%97%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FUserActionLogsController_getUserActionLogs",
      apiNumber: 2,
    },
    {
      icon: "website-dashboard-3-line",
      title: t("open.api.content.manageCost"),
      url:
        "?tag=tag%2F%E7%AE%A1%E7%90%86%E8%AE%A1%E9%87%8F%E8%AE%A1%E8%B4%B9%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FCostManagementController_getCurrentPackageInfo",
      apiNumber: 7,
    },
  ];

  const secondProducts = [
    {
      icon: "website-newspaper-line",
      title: t("open.api.content.messageAuth"),
      url:
        "?tag=tag%2F%E6%B6%88%E6%81%AF%E6%9C%8D%E5%8A%A1%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FMessageV3Controller_sendSms",
      apiNumber: 2,
      widthPercent: 2,
    },
    {
      icon: "website-wechat-2-line",
      title: t("open.api.content.wechatAuth"),
      url:
        "?tag=tag%2F%E5%BE%AE%E4%BF%A1%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FWechatAPIV3Controller_decryptWechatMiniProgramData",
      apiNumber: 3,
      widthPercent: 2,
    },
    {
      icon: "website-shield-check-line",
      title: t("open.api.content.login"),
      url: "?tag=tag%2F%E7%99%BB%E5%BD%95%2F%E6%A6%82%E8%BF%B0",
      apiNumber: 10,
    },
    {
      icon: "website-command-fill",
      title: t("open.api.content.manageToken"),
      url: "?tag=tag%2F%E7%AE%A1%E7%90%86%20Token%2F%E6%A6%82%E8%BF%B0",
      apiNumber: 3,
    },
    {
      icon: "website-logout-box-line",
      title: t("open.api.content.logout"),
      url: "?tag=tag%2F%E7%99%BB%E5%87%BA%2F%E6%A6%82%E8%BF%B0",
      apiNumber: 1,
    },
    {
      icon: "website-registered-line",
      title: t("open.api.content.register"),
      url: "?tag=tag%2F%E6%B3%A8%E5%86%8C%2F%E6%A6%82%E8%BF%B0",
      apiNumber: 1,
    },
    {
      icon: "website-file-user-line",
      title: t("open.api.content.userInfo"),
      url:
        "?tag=tag%2F%E7%94%A8%E6%88%B7%E8%B5%84%E6%96%99%2F%E6%A6%82%E8%BF%B0",
      apiNumber: 16,
    },
    {
      icon: "website-shield-user-line",
      title: t("open.api.content.bind"),
      url:
        "?tag=tag%2F%E8%B4%A6%E5%8F%B7%E7%BB%91%E5%AE%9A%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FExtIdpAuthenticationV3Controller_linkExtIdp",
      apiNumber: 12,
    },
    {
      icon: "website-secure-userinfo-fill1",
      title: t("open.api.content.mfa"),
      url:
        "?tag=tag%2FMFA%20%E8%A6%81%E7%B4%A0%E7%AE%A1%E7%90%86%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FFactorsV3Controller_sendEnrollFactorRequest",
      apiNumber: 7,
    },
    {
      icon: "website-folder-user-line",
      title: t("open.api.content.userAbouts"),
      url:
        "?tag=tag%2F%E7%94%A8%E6%88%B7%E7%9B%B8%E5%85%B3%E8%B5%84%E6%BA%90%2FAPI%20%E5%88%97%E8%A1%A8%2Foperation%2FUserRelatedResourceAPIV3Controller_getLoginHistory",
      apiNumber: 8,
    },
  ];

  useEffect(() => {
    new Swiper(".api-swipe", {
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
      },
    });
  }, [swipeNum]);

  return (
    <div className="open-page-api">
      <Title title={t("open.api.title")} desc={t("open.api.desc")} />
      <div className="open-page-api-tabs">
        {tabs.map((tab, tabIndex) => (
          <div
            className={classNames({
              "open-page-api-tab": true,
              active: currentPanel === tab.value,
            })}
            onClick={() => setCurrentPanel(tab.value)}
            key={tab.value}
          >
            <img src={tab.icon} alt="" className="api-tab-icon" />
            <div className="api-tab-label">{tab.label}</div>
            {currentPanel === tab.value && (
              <div
                className={classNames("api-tab-link", {
                  self__backInLeft: tabIndex === 1,
                  self__backInRight: tabIndex === 0,
                })}
              ></div>
            )}
          </div>
        ))}
      </div>
      <div className="open-page-api-container">
        <div
          style={{
            display: currentPanel === "firstPanel" ? "block" : "none",
          }}
        >
          {swipeNum ? (
            <div className="open-page-api-content api-swipe open-page-api-item">
              <div class="swiper-wrapper">
                {[
                  firstProducts.slice(0, swipeNum),
                  firstProducts.slice(swipeNum, firstProducts.length),
                ].map((product) => {
                  return (
                    <div class="swiper-slide basic-column open-page-api-item">
                      {product.map((item) => {
                        return (
                          <CardProduct
                            {...item}
                            exchange
                            key={item.title}
                            spacing={swipeNum ? 16 : 24}
                          />
                        );
                      })}
                    </div>
                  );
                })}
              </div>
              <div class="swiper-pagination"></div>
            </div>
          ) : (
            <div className="basic-column open-page-api-content open-page-api-item">
              {firstProducts.map((item) => {
                return (
                  <CardProduct
                    {...item}
                    exchange
                    key={item.title}
                    spacing={swipeNum ? 16 : 24}
                  />
                );
              })}
            </div>
          )}
        </div>
        <div
          style={{
            display: currentPanel === "secondPanel" ? "block" : "none",
          }}
        >
          <div className="basic-column open-page-api-content open-page-api-item">
            {secondProducts.map((item) => {
              return (
                <CardProduct
                  align
                  {...item}
                  key={item.title}
                  spacing={swipeNum ? 16 : 24}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
